<template>
  <div
    class="card-info"
    ref="cardInfo"
    :style="{
      overflowY: modalName === true ? 'hidden' : 'auto',
    }"
  >
    <slot />
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    lstPosition: 0,
  }),
  name: "cardInfo",
  computed: {
    ...mapState(["modalName"]),
  },
  watch: {
    modalName(val) {
      if (val === true) {
        this.lstPosition = this.$refs.cardInfo.scrollTop;
        this.$refs.cardInfo.scrollTop = 0;
      } else {
        this.$refs.cardInfo.scrollTop = this.lstPosition;
      }
    },
  },
};
</script>
<style>
</style>
